<template lang="pug">
.simple-tooltip(:class="{ relative: showing }" ref="elRef")
  .simple-tooltip-owner
    slot

  .simple-tooltip-content.absolute(
    :class="[showing ? 'visible' : 'invisible ', twMerge('translate-y-100 p-1 top-[100%] min-w-[10ch] max-w-[100vw]', classes)]"
    role="tooltip"
    v-bind="attrs"
    v-if="text"
  ) 
    p.text-sm.bg-gray-900.bg-opacity-80.text-white.rounded.border-8.border-transparent.transition(
      :class="[{ 'opacity-0 scale-75': !showing }]"
    ) {{ text }}
</template>

<script lang="ts" setup>
import { useEventListener } from '@vueuse/core';
import { ref, useAttrs, computed } from 'vue';
import { createPopper } from '@popperjs/core';
import type { Instance } from '@popperjs/core';
import { twMerge } from 'tailwind-merge';

defineOptions({ inheritAttrs: false });
const attrs = useAttrs();
const classes = computed(() => (useAttrs().class || '') as string);

const props = defineProps<{
  text: string;
  position?: 'top' | 'bottom' | 'left' | 'right';
}>();

const popperInstance = ref<Instance>();
const elRef = ref<HTMLElement>();
const showing = ref(false);

const show = () => {
  const [owner, tooltip] = elRef.value
    ?.children as HTMLCollectionOf<HTMLElement>;

  if (!owner || !tooltip) return;

  showing.value = true;

  popperInstance.value = createPopper(owner, tooltip, {
    placement: props.position || 'bottom'
  });
};

const hide = () => {
  showing.value = false;
  popperInstance.value?.destroy();
  popperInstance.value = undefined;
};

useEventListener(elRef, 'mouseenter', show);
useEventListener(elRef, 'mouseleave', hide);
useEventListener(elRef, 'focusin', show);
useEventListener(elRef, 'focusout', hide);
</script>
